import logo from "./logo.svg";
// import "./App.css";
import { Layout, ConfigProvider } from "antd";
// import "antd/dist/antd.less";
import 'antd/dist/antd.min.css';

import React from "react";
import "./App.less";
import Pages from "./pages/index";
import moment from "moment";
import "moment/locale/zh-cn";
import locale from "antd/lib/locale/zh_CN";
import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';


function App() {
  return (
    <div className="App">
      <Pages />
    </div>
  );
}

export default App;
